/* tslint:disable:no-bitwise */
import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { URLSearchParams, Response } from '@angular/http';

import { Api } from './api.service';
import { TrackerStatusService } from './trackerstatus.service';
import { TRACKER_TYPES, PAGINATION_NUMBER } from './constants.service';
import { CrudInterface } from './crud.interface';
import { TrackerAdmin, Retailer, TrackerStatus, ListResult, ITrackerFilter } from '../entities/index';
import { Log } from '../utils/index';

const find = (collection: Array<any>, property: string, value: string, strict: boolean = false) => {
  value = value.toLowerCase();
  return _.find(collection, item => {
    if (strict) {
      return String(property ? item[property] : item).toLowerCase() === value;
    } else {
      return !!~String(property ? item[property] : item).toLowerCase().indexOf(value);
    }
  });
};


const findField = (term: string, types: string[], statuses: TrackerStatus[]): any => {
  let found: any;
  if (found = find(types, null, term)) {
    return {type: found};
  }
  if (found = find(statuses, 'code', term)) {
    return {status_id: found.id};
  }
  return {search: term};
};


@Injectable()
export class TrackerAdminService implements CrudInterface<TrackerAdmin> {

  constructor(protected http: Api,
              protected trackerStatusService: TrackerStatusService
      ) {
  }

  @Log('green')
  list(search: string = null, page: number = 1, limit: number = PAGINATION_NUMBER, filters?: ITrackerFilter): Observable<ListResult<TrackerAdmin>> {
    const params = new URLSearchParams();
    if (search) {
      this._buildSearch(params, search);
    }
    if (page) {
      params.set('page', String(page));
    }
    if (limit) {
      params.set('limit', String(limit));
    }
    if(filters) {
      params.setAll(this.http.buildUrlSearchParams(filters));
    }

    return this.http.get('trackeradmin', {search: params});
  }

  @Log('green')
  findOneByImei(imei: string): Observable<TrackerAdmin> {
    return this.list(imei).map((res: ListResult<TrackerAdmin>) => {
      return res.total === 1 ? res.items[0] : null;
    });
  }

  @Log('green')
  get(id: number): Observable<TrackerAdmin> {
    return this._returnTrackerAdmin(this.http.get(`trackeradmin/${id}`));
  }

  @Log('green')
  create(trackerAdmin: TrackerAdmin): Observable<TrackerAdmin> {
    return this._returnTrackerAdmin(this.http.post('trackeradmin', trackerAdmin));
  }

  @Log('green')
  update(trackerAdmin: TrackerAdmin): Observable<TrackerAdmin> {
    const trackerAdminId = trackerAdmin.id;
    return this._returnTrackerAdmin(this.http.put(`trackeradmin/${trackerAdminId}`, trackerAdmin));
  }

  save(trackerAdmin: TrackerAdmin): Observable<TrackerAdmin> {
    const isNew = undefined === trackerAdmin.id;
    if (isNew) {
      return this.create(trackerAdmin);
    } else {
      return this.update(trackerAdmin);
    }
  }

  @Log('green')
  remove(trackerAdmin: TrackerAdmin): Observable<Response> {
    const trackerAdminId = trackerAdmin.id;
    return this.http.delete(`trackeradmin/${trackerAdminId}`);
  }

  @Log('green')
  importCsv(file: File): Observable<number> {
    return this.http.makeFileRequest('task/tracker', file).map(res => res.id);
  }

  @Log('green')
  activateSim(trackerAdminId: number): Observable<Response> {
    return this.http.post(`trackeradmin/${trackerAdminId}/sim`, {});
  }

  @Log('green')
  deactivateSim(trackerAdminId: number): Observable<Response> {
    return this.http.delete(`trackeradmin/${trackerAdminId}/sim`);
  }

  protected _returnTrackerAdmin(action: Observable<TrackerAdmin>): Observable<TrackerAdmin> {
    return Observable.forkJoin(
      action,
      this.trackerStatusService.getAll()
    ).map((result: [TrackerAdmin, TrackerStatus[]]) => {
      const trackerAdmin = result[0];

      // Overwrite retailer and status attribute with already loaded references
      const trackerStatusId = trackerAdmin && trackerAdmin.status && trackerAdmin.status.id;
      const trackerStatus = find(result[1], 'id', String(trackerStatusId), true);
      const retailerId = trackerAdmin && trackerAdmin.retailer && trackerAdmin.retailer.id;

      trackerAdmin.status = trackerStatus;
      return trackerAdmin;
    });
  }

  protected _buildSearch(params: URLSearchParams, search: string): void {
    let filters = _(search.split(/ +/))
      .map(term => findField(term, TRACKER_TYPES, this.trackerStatusService.dataStore))
      .reduce(_.merge, {});

    filters = _.omitBy(filters, (i: any) => !i);

    _.forOwn(filters, (value, key) => {
      params.set(key, value);
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/trackeradmin.service.ts